export default "__VITE_ASSET__CqJ91EEn__"